import React, { Component } from 'react';
import { string, bool, func, number } from 'prop-types';
import ThumbsUpSvg from 'library/icons/thumb-up.svg';
import * as StyledCareerClusterCheckboxes from 'apps/career-clusters/components/career-clusters-survey/survey-sections/styled-career-clutsers-checkbox';



const Animations = ({ animation }) => animation == 'trans-active'
  ? <StyledCareerClusterCheckboxes.RotateUp> <ThumbsUpSvg/> </StyledCareerClusterCheckboxes.RotateUp>
  : <StyledCareerClusterCheckboxes.RotateDown> <ThumbsUpSvg/> </StyledCareerClusterCheckboxes.RotateDown>;


class CareerClusterCheckbox extends Component  {
  state = {
    transState: null
  };

  handleTransitions = () => {
    const { toggleActive, id, active } = this.props;
    const transState = `trans-${active ? 'inactive' : 'active'}`;
    this.setState({ transState }, () => {
      setTimeout(() => this.setState({transState: 'null'},
        toggleActive(id)), 300);});
  };



  render() {
    const {  question, active=false } = this.props;
    const { transState } = this.state;

    return(
      <StyledCareerClusterCheckboxes.StyledCareerClusterCheckbox onClick={this.handleTransitions} active={active || transState == 'trans-active' || transState == 'trans-inactive'}>
        <div className="check-circle" >
          {
            ['trans-active', 'trans-inactive'].includes(transState)
              ? <Animations animation={transState} />
              : <ThumbsUpSvg/>
          }
        </div>
        <div className="question-title">
          {question}
        </div>
      </StyledCareerClusterCheckboxes.StyledCareerClusterCheckbox>
    );
  }
}

CareerClusterCheckbox.propTypes = {
  question: string,
  active: bool,
  toggleActive: func,
  id: number
};

Animations.propTypes = {
  animation: string
};

export default CareerClusterCheckbox;
